import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useCleanupRedux } from '../../common/hooks'
import { apolloService } from '../../common/services'

import { LOCATIONS_QUERY } from '../graphql/queries'
import { FETCH_LOCATIONS } from '../redux/action-types'
import { cleanupFetchLocations } from '../redux/actions'

const useLocationsQuery = (
  { brandId } = {},
  { pageSize, currentPage } = {},
) => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupFetchLocations)
  const { isLoading, error, data } = useSelector(
    store => store.locations.locations,
  )
  const refetch = useCallback(
    (filtersParam, paginationParam) =>
      apolloService.query({
        query: LOCATIONS_QUERY,
        variables: {
          filters: filtersParam,
          pagination: paginationParam,
        },
        dispatch,
        action: FETCH_LOCATIONS,
      }),
    [dispatch],
  )

  useEffect(() => {
    refetch({ brandId }, { pageSize, currentPage })
  }, [refetch, brandId, pageSize, currentPage])

  return { isLoading, error, data, refetch }
}

export default useLocationsQuery
